export interface DiscountValues {
    gas: string;
    electricity: string;
}

export interface DiscountConditionForm {
    hasDirectDebit: boolean;
    hasElectronicInvoice: boolean;
}

export interface IDiscount {
    id: string;
    title: string;
    description: string;
    values: DiscountValues;
    tariff: string;
    contractType: string;
    isChecked: boolean;
    form: string;
    current: boolean;
    type: string;
}

export class Discount implements IDiscount {
    constructor(
        public id: string,
        public title: string,
        public description: string,
        public values: DiscountValues,
        public tariff: string,
        public contractType: string,
        public isChecked: boolean,
        public form: string,
        public current: boolean,
        public type: string,
    ) {
        const gas = Number(values.gas);
        values.gas = gas.toString();

        const electricity = Number(values.electricity);
        values.electricity = electricity.toString();
    }

    public checkCondition(condition: string): boolean {
        const conditions: DiscountConditionForm = this.getForm();

        return conditions ? conditions[condition] : false;
    }

    public getForm(): DiscountConditionForm {
        return JSON.parse(this.form);
    }
}

export class DiscountFactory {
    static create(discount: any): Discount {
        return new Discount(
            discount.id,
            discount.title,
            discount.description,
            discount.values,
            discount.tariff,
            discount.contractType,
            discount.isChecked,
            discount.form,
            discount.current,
            discount.type,
        );
    }
}
